<template>
    <section class="main">
        <div v-show="isObjectLoading">
            <v-page-loading />
        </div>
        <div v-show="!isObjectLoading">
            <v-page-header :title="getPageTile" :showPrevButton="true" />

            <div class="grid-container">
                <div class="grid-x">
                    <div class="cell medium-9 medium-offset-1 large-11 large-offset-0">
                        <div class="wrapper">
                            <div v-show="hasObjectFatalError">
                                <p class="text-center">{{ objectFatalError }}</p>
                            </div>

                            <div v-show="!hasObjectFatalError">
                                <v-action-buttons :items="getActionButtons" :isDisabled="objectFormDisabled" @actionClicked="onClickAction" />
                                <v-form-message type="error" id="form-error" :message="objectError" @onClickAction="onClickActivateDialogAction" />
                                <v-form-message type="success" id="form-success" :message="objectSuccess" @onClickAction="onClickActivateDialogAction" />
                                <v-form-message type="default" id="form-activate" :message="objectActivateMessage" :autoCloseTimeout="0" :showActionButtons="true" @onClickAction="onClickActivateDialogAction" />

                                <div class="box">
                                    <div class="form-group--wrapper">
                                        <div class="grid-x grid-padding-x">
                                            <div class="cell medium-12 large-6">
                                                <div class="form-block">
                                                    <h2>{{ $t('form.customer.title.customer') }}</h2>
                                                    <div class="form-group form-group--required" :class="{ 'form-group--error' : $v.object.client_number.$error }">
                                                        <label for="form-field-client-number">{{ $t('customers.client_number') }}</label>
                                                        <input type="text" id="form-field-client-number" name="client_number" class="form-control" placeholder="12345678" v-model="$v.object.client_number.$model" />
                                                    </div>
                                                    <div class="form-group form-group--required" :class="{ 'form-group--error' : $v.object.company_name.$error }">
                                                        <label for="form-field-company-name">{{ $t('customers.company_name') }}</label>
                                                        <input type="text" id="form-field-company-name" name="company_name" class="form-control" placeholder="Musterfirma"  v-model="$v.object.company_name.$model" />
                                                    </div>
                                                    <div class="form-group">
                                                        <label for="form-field-contact-person">{{ $t('customers.contact_person') }}</label>
                                                        <input type="text" id="form-field-contact-person" name="contact_person" class="form-control" placeholder=""  v-model="object.contact_person" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="cell medium-12 large-6">
                                                <div class="form-block">
                                                    <h2>{{ $t('form.customer.title.hq_location') }}</h2>
                                                    <div class="form-group">
                                                        <label>{{ $t('customers.location_number') }}</label>
                                                        <div class="form-control form-control--static">
                                                            {{ object.headquarter.location_number }}
                                                        </div>
                                                    </div>
                                                    <div class="form-group form-group--required" :class="{ 'form-group--error' : $v.object.headquarter.address1.$error }">
                                                        <label for="form-field-adress1">{{ $t('form.address1') }}</label>
                                                        <input type="text" id="form-field-adress1" name="address1" class="form-control" :placeholder="$t('form.address1.plc')" v-model="$v.object.headquarter.address1.$model" />
                                                    </div>
                                                    <div class="form-group">
                                                        <label for="form-field-adress2">{{ $t('form.address2') }}</label>
                                                        <input type="text" id="form-field-adress2" name="address2" class="form-control" :placeholder="$t('form.address2.plc')" v-model="object.headquarter.address2" />
                                                    </div>
                                                    <div class="grid-x grid-margin-x">
                                                        <div class="cell medium-6">
                                                            <div class="form-group form-group--small form-group--required" :class="{ 'form-group--error' : $v.object.headquarter.zipcode.$error }">
                                                                <label for="form-field-zipcode">{{ $t('form.zipcode') }}</label>
                                                                <input type="text" id="form-field-zipcode" name="zipcode" class="form-control" :class="{'loading-spinner--input' : geocodeLoading}" :placeholder="$t('form.zipcode.plc')" v-model="$v.object.headquarter.zipcode.$model" @keyup="onChangeZipcode" />
                                                            </div>
                                                            <div class="form-group" v-if="geocodeObject.zipcode.length > 1">
                                                                <select name="zipcode_list" class="form-control form-control--select" @change="onSelectZipcode">
                                                                    <option value="">{{ $t('form.zipcode.choose')}}</option>
                                                                    <option v-for="item in geocodeObject.zipcode" :value="item.zipcode">
                                                                        {{ item.zipcode }}
                                                                    </option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div class="cell medium-6">
                                                            <div class="form-group form-group--small form-group--required" :class="{ 'form-group--error' : $v.object.headquarter.city.$error }">
                                                                <label for="form-field-city">{{ $t('form.city') }}</label>
                                                                <input type="text" id="form-field-city" name="city" class="form-control" :class="{'loading-spinner--input' : geocodeLoading}" :placeholder="$t('form.city.plc')" v-model="$v.object.headquarter.city.$model" @keyup="onChangeCity" />
                                                            </div>
                                                            <div class="form-group" v-if="geocodeObject.city.length > 1">
                                                                <select name="city_list" class="form-control form-control--select" @change="onSelectCity">
                                                                    <option value="">{{ $t('form.city.choose')}}</option>
                                                                    <option v-for="item in geocodeObject.city" :value="item.city">
                                                                        {{ item.city }}
                                                                    </option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="form-group form-group--required" :class="{ 'form-group--error' : $v.object.headquarter.country_code.$error }">
                                                        <label for="form-field-country">{{ $t('customers.country') }}</label>
                                                        <v-select-country id="form-field-country" v-model="$v.object.headquarter.country_code.$model" />
                                                    </div>
                                                    <div class="form-group form-group--required" :class="{ 'form-group--error' : $v.object.headquarter.phone.$error }">
                                                        <label for="form-field-phone">{{ $t('form.phone') }}</label>
                                                        <input type="tel" id="form-field-phone" name="phone" class="form-control" :placeholder="$t('form.phone.plc')" v-model="$v.object.headquarter.phone.$model" />
                                                    </div>
                                                    <div class="form-group form-group--required" :class="{ 'form-group--error' : $v.object.headquarter.email.$error }">
                                                        <label for="form-field-email">{{ $t('form.email') }}</label>
                                                        <input type="email" id="form-field-email" name="email" class="form-control" :placeholder="$t('form.email.plc')" v-model="$v.object.headquarter.email.$model" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import PageHeader from '../partials/PageHeader';
    import PageLoading from '../partials/PageLoading';
    import ActionButtons from './../partials/Foundation/ActionButtons';
    import FormMessage from './../partials/Forms/FormMessage';
    import { required, email } from 'vuelidate/lib/validators';
    import _ from 'lodash';

    import SelectCountry from './../partials/Forms/SelectCountry';

    export default {
        data() {
            return {
                objectLoading           : false,
                objectSuccess           : null,
                objectError             : null,
                objectFatalError        : null,
                objectFormDisabled      : false,
                objectActivateMessage   : null,
                object                  : {
                    id                      : 0,
                    client_number           : '',
                    company_name            : '',
                    active                  : 1,
                    headquarter             : {
                        id                      : 0,
                        customer_id             : 0,
                        location_number         : 'n/a',
                        address1                : '',
                        address2                : '',
                        zipcode                 : '',
                        city                    : '',
                        country_code            : 'de',
                        phone                   : '',
                        email                   : '',
                        is_hq                   : 1
                    }
                },
                geocodeLoading          : false,
                geocodeObject           : {
                    zipcode                 : [],
                    city                    : []
                }
            };
        },
        components : {
            vPageHeader         : PageHeader,
            vPageLoading        : PageLoading,
            vActionButtons      : ActionButtons,
            vFormMessage        : FormMessage,
            vSelectCountry      : SelectCountry
        },
        computed : {
            isCreateMethod : function () {
                return this.$route.meta.method === 'create';
            },
            isUpdateMethod : function () {
                return this.$route.meta.method === 'update';
            },
            isObjectLoading : function () {
                return this.objectLoading;
            },
            hasObjectFatalError : function () {
                return this.objectFatalError !== null;
            },
            getActionButtons : function () {
                let buttons = [];

                if (this.isCreateMethod) {
                    if (this.$store.getters.userHasPermission('customer_create')) {
                        buttons.push({
                            action : 'save'
                        });
                    }
                }

                if (this.isUpdateMethod) {
                    if (this.object) {
                        if (this.$store.getters.userHasPermission('customer_update')) {
                            buttons.push({
                                action : 'save'
                            });
                        }

                        if (this.$store.getters.userHasPermission('customer_activate')) {
                            if (this.object.active) {
                                buttons.push({
                                    action : 'deactivate'
                                });
                            } else {
                                buttons.push({
                                    action : 'activate'
                                });
                            }
                        }
                    }
                }

                buttons.push({
                    action : 'cancel',
                    router  : { name : 'customers' }
                });

                return buttons;
            },
            getPageTile : function () {
                return this.$t('customer.customer.' + this.$route.meta.method + '.title');
            }
        },
        watch : {
            '$route' : {
                handler : function () {
                    this.onUpdateObject();
                },
                deep    : true
            }
        },
        created : function () {
            this.onUpdateObject();
        },
        validations : function () {
            return {
                object : {
                    client_number : {
                        required
                    },
                    company_name : {
                        required
                    },
                    headquarter : {
                        address1 : {
                            required
                        },
                        zipcode : {
                            required
                        },
                        city : {
                            required
                        },
                        country_code : {
                            required
                        },
                        phone : {
                            required
                        },
                        email : {
                            required,
                            email
                        }
                    }
                }
            }
        },
        methods : {
            onClickAction : function (action) {
                this.objectError            = null;
                this.objectSuccess          = null;
                this.objectActivateMessage  = null;

                switch (action) {
                    case 'save':
                        this.onSubmitObject();

                        break;
                    case 'activate':
                    case 'deactivate':
                        this.onActivateObject();

                        break;
                }
            },
            onClickActivateDialogAction : function (id, action) {
                this.objectError            = null;
                this.objectSuccess          = null;
                this.objectActivateMessage  = null;

                switch (action) {
                    case 'yes':
                        if (id === 'form-activate') {
                            this.onActivateObjectSubmit();
                        }

                        break;
                }
            },
            onUpdateObject : function () {
                this.objectFatalError = null;

                if (this.isCreateMethod) {
                    this.objectLoading = false;
                } else {
                    let promise = this.$api.clearParams()
                        .get('customers/' + this.$route.params.customer + '/get');

                    promise.then((response => {
                        this.object = response.data.data;
                    }).bind(this)).catch((error => {
                        this.objectFatalError = error.response.data.message;
                    }).bind(this)).finally((() => {
                        this.objectLoading = false;
                    }).bind(this));

                    this.objectLoading = true;
                }
            },
            onSubmitObject : function () {
                this.objectError        = null;
                this.objectSuccess      = null;
                this.objectFormDisabled = true;

                this.$v.object.$touch();

                if (this.$v.object.$invalid) {
                    this.objectError        = this.$t('form.error_form');
                    this.objectFormDisabled = false;
                } else {
                    if (this.isCreateMethod) {
                        let promise = this.$api.clearParams()
                            .post('customers/create', this.object);

                        promise.then((response => {
                            /**
                             * @TODO Fix the headquater call in the API.
                             */
                            this.object.headquarter.customer_id             = response.data.data.id;
                            this.object.headquarter.company_name            = response.data.data.company_name;
                            this.object.headquarter.project_number_required = response.data.data.project_number_required;

                            let promise = this.$api.clearParams()
                                .post('locations/create', this.object.headquarter);

                            promise.then((response => {
                                this.objectSuccess      = this.$t('customer.customer.create.success');
                                this.objectFormDisabled = false;

                                this.$router.push({ name : 'customers-update-customer', params : { customer : response.data.data.customer_id } });
                            }).bind(this)).catch((error => {
                                this.objectError        = error.response.data.message;
                                this.objectFormDisabled = false;
                            }).bind(this));
                        }).bind(this)).catch((error => {
                            this.objectError        = error.response.data.message;
                            this.objectFormDisabled = false;
                        }).bind(this));
                    } else if (this.isUpdateMethod) {
                        let promise = this.$api.clearParams()
                            .post('customers/' + this.$route.params.customer + '/update', this.object);

                        promise.then((response => {
                            /**
                             * @TODO Fix the headquater call in the API.
                             */
                            this.object.headquarter.customer_id             = response.data.data.id;
                            this.object.headquarter.company_name            = response.data.data.company_name;
                            this.object.headquarter.project_number_required = response.data.data.project_number_required;

                            let promise = this.$api.clearParams()
                                .post('locations/' + this.object.headquarter.id + '/update', this.object.headquarter);

                            promise.then((response => {
                                this.objectSuccess      = this.$t('customer.customer.update.success');
                                this.objectFormDisabled = false;
                            }).bind(this)).catch((error => {
                                this.objectError        = error.response.data.message;
                                this.objectFormDisabled = false;
                            }).bind(this));
                        }).bind(this)).catch((error => {
                            this.objectError        = error.response.data.message;
                            this.objectFormDisabled = false;
                        }).bind(this));
                    }
                }
            },
            onActivateObject : function () {
                if (!this.object.active) {
                    this.objectActivateMessage = this.$t('customer.customer.active');
                } else {
                    this.objectActivateMessage = this.$t('customer.customer.deactive');
                }
            },
            onActivateObjectSubmit : function () {
                this.objectSuccess          = null;
                this.objectError            = null;
                this.objectFormDisabled     = true;
                this.objectActivateMessage  = null;

                let promise = this.$api.clearParams()
                    .post('customers/' + this.$route.params.customer + '/activate', {
                        active : !this.object.active
                    });

                promise.then((response => {
                    if (response.data.data.active) {
                        this.objectSuccess  = this.$t('customer.customer.active.success');
                    } else {
                        this.objectSuccess  = this.$t('customer.customer.deactive.success');
                    }

                    this.objectFormDisabled = false;

                    this.object.active      = response.data.data.active;
                }).bind(this)).catch((error => {
                    this.objectError        = error.response.data.message;
                    this.objectFormDisabled = false;
                }).bind(this));
            },
            onChangeZipcode : _.debounce(function(event) {
                if (event.target.value !== '') {
                    this.getGeocodeResult(event.target.value, 'zipcode', 'city');
                }
            }, 500),
            onChangeCity : _.debounce(function(event) {
                if (event.target.value !== '') {
                    this.getGeocodeResult(event.target.value, 'city', 'zipcode');
                }
            }, 500),
            onSelectZipcode : function (event) {
                this.object.headquarter.zipcode = event.target.value;

                this.geocodeObject.zipcode = [];
            },
            onSelectCity : function (event) {
                this.object.headquarter.city = event.target.value;

                this.geocodeObject.city = [];
            },
            getGeocodeResult : function (value, type, target) {
                let promise = this.$geocoder.search(value, type);

                promise.then((response => {
                    let results = [];

                    response.data.data.forEach((function (row) {
                        results.push(row);
                    }).bind(this));

                    if (results.length === 1) {
                        this.object.headquarter[target] = results[0][target];
                    } else {
                        this.geocodeObject[target] = results;
                    }

                    this.geocodeObject[type]    = [];
                }).bind(this)).catch((error => {
                    this.geocodeObject[target]  = [];
                    this.geocodeObject[type]    = [];
                }).bind(this)).finally((() => {
                    this.geocodeLoading = false;
                }).bind(this));

                this.geocodeLoading = true;
            }
        }
    }
</script>